import { StyleSheet } from 'react-native'
import { layoutStyles } from 'styles/layout'

export const ListItemStyles = StyleSheet.create({
	row: {
		alignItems: 'flex-start',
		justifyContent: 'center',
	},
	
	colEnd: {
		width: 'auto',
		paddingLeft: 4,
	},
	
	colCenter: {
		alignItems: 'center'
	},
	
	colActiveTag: {
		flex: undefined,
		alignItems: 'flex-start',
		justifyContent: 'center',
		minWidth: 80,
		width: 'auto',
	},
	
	colAccessoryLeft: {
		// flex: 0,
		alignItems: 'center',
		justifyContent: 'center',
		minWidth: 'auto',
		width: 'auto',
		paddingHorizontal: 8,
	},
	
	colAccessoryRight: {
		width: 120,
		minWidth: 'auto',
		alignItems: 'flex-end',
		justifyContent: 'center',
	},
	
	badgeContainer: {
		alignItems: 'flex-start',
		justifyContent: 'flex-start',
		height: '100%'
	}
})
